import React from "react";

export default function QuizzLoadingState() {
  return (
    <div className="space-y-4">
      <div className="h-4 w-40 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
      <div className="h-3 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div
            className="animate-pulse rounded-[26px] bg-slate-200 dark:bg-slate-800"
            style={{ aspectRatio: "551 / 617" }}
          />
        </div>

        <div className="space-y-3 lg:col-span-5">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="h-14 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800"
            />
          ))}

          <div className="h-14 animate-pulse rounded-2xl bg-slate-300 dark:bg-slate-700" />
        </div>
      </div>
    </div>
  );
}